var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	9897: {
		fallback: () => (__webpack_require__.e(979).then(() => (() => (__webpack_require__(1979))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	6861: {
		fallback: () => (__webpack_require__.e(327).then(() => (() => (__webpack_require__(7708))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	8398: {
		fallback: () => (__webpack_require__.e(627).then(() => (() => (__webpack_require__(1627))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	8578: {
		fallback: () => (__webpack_require__.e(182).then(() => (() => (__webpack_require__(7182))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "swr",

	},
	1984: {
		fallback: () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(861)]).then(() => (() => (__webpack_require__(6385))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"112": [
		1984
	],
	"567": [
		8398,
		8578
	],
	"861": [
		6861
	],
	"897": [
		9897
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}